import { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import * as S from "./BarChart.style";

interface BarChartProps {
  data?: any;
  onLowMachinaryGraphClicked: (params: any) => void;
}

export const BarChart = ({
  data,
  onLowMachinaryGraphClicked,
}: BarChartProps) => {
  const options = useMemo(
    () => ({
      xAxis: {
        type: "category",
        data: data?.section,
        axisLabel: {
          interval: 0, // 모든 라벨을 표시
          formatter: (value: string) =>
            value.length > 10 ? `${value.slice(0, 10)}...` : value, // 라벨 길이가 너무 길 경우 줄이기
        },
      },
      yAxis: {
        type: "value",
      },
      series: [{ data: data?.value, type: "bar" }],
      grid: {
        containLabel: true,
        left: 10,
        top: 10,
        right: 10,
        bottom: 0,
      },
    }),
    [data]
  );

  const onEvent = {
    click: onLowMachinaryGraphClicked,
  };

  return (
    <S.BarChartBox>
      <ReactECharts
        option={options}
        opts={{ renderer: "canvas" }}
        style={{ width: "100%", height: "100%" }}
        onEvents={onEvent}
      />
    </S.BarChartBox>
  );
};
